import React from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/Content.css'
import c1 from './../assest/images/content writing 19/content writing 1.jpg'
import c2 from './../assest/images/content writing 19/content writing 10.jpg'
import c3 from './../assest/images/content writing 19/content writing 11.jpg'
import c4 from './../assest/images/content writing 19/content writing 12.jpg'
import c5 from './../assest/images/content writing 19/content writing 13.jpg'
import c6 from './../assest/images/content writing 19/content writing 14.jpg'
import c7 from './../assest/images/content writing 19/content writing 15.jpg'
import c8 from './../assest/images/content writing 19/content writing 16.jpg'
import c9 from './../assest/images/content writing 19/content writing 17.jpg'
import c10 from './../assest/images/content writing 19/content writing 18.jpg'
import c11 from './../assest/images/content writing 19/content writing 19.jpg'
import c12 from './../assest/images/content writing 19/content writing 2.jpg'
import c13 from './../assest/images/content writing 19/content writing 3.jpg'
import c14 from './../assest/images/content writing 19/content writing 4.jpg'
import c15 from './../assest/images/content writing 19/content writing 5.jpg'
import c16 from './../assest/images/content writing 19/content writing 6.jpg'
import c17 from './../assest/images/content writing 19/content writing 7.jpg'
import c18 from './../assest/images/content writing 19/content writing 8.jpg'
import c19 from './../assest/images/content writing 19/content writing 9.jpg'
import Slider from 'react-slick'
export const Content = () => {
    const cdata=[
        {
            cover:c1,
            tite:"Content writing - Medical content"
        },
        {
            cover:c2,
            tite:"Content writing - Medical content"
        },
        {
            cover:c3,
            tite:"Content writing - Medical content"
        },
        {
            cover:c4,
            tite:"Content writing - Medical content"
        },
        {
            cover:c5,
            tite:"Content writing - Medical content"
        },
        {
            cover:c6,
            tite:"Content writing - Medical content"
        },
        {
            cover:c7,
            tite:"sContent writing - Marketing"
        },
        {
            cover:c8,
            tite:"Content writing - Marketing"
        },
        {
            cover:c9,
            tite:"Content writing - Marketing"
        },
        {
            cover:c10,
            tite:"Content writing - Marketing"
        },
        {
            cover:c11,
            tite:"Content writing - Marketing"
        },
        {
            cover:c12,
            tite:"Content writing - Marketing"
        },
        {
            cover:c13,
            tite:"Content writing - Real Estate"
        },
        {
            cover:c14,
            tite:"Content writing - Real Estate"
        },
        {
            cover:c15,
            tite:"Content writing - Real Estate"
        },
        {
            cover:c16,
            tite:"Content writing - Real Estate"
        },
        {
            cover:c17,
            tite:"Content writing - Real Estate"
        },
        {
            cover:c18,
            tite:"Content writing - Real Estate"
        },
        {
            cover:c19,
            tite:"Content writing - Real Estate"
        },

    ]

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 2,
              initialSlide: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      };
  return (
    <div className='contents'>
        <Container>
<div className='row'>
<Slider {...settings}>
    {cdata.map((value,index)=>{
        return(
            <div className='bost' key={index}>
                <div className='topname d-flex'>
                <span className='left'>{value.tite}</span>
               
                </div>
                <div className='img'>
                <img src={value.cover}/>
                </div>
            </div>
        )
    }) }
    </Slider>
</div>
        </Container>
    </div>
  )
}
